import { render, staticRenderFns } from "./NewRsInspectionReport.vue?vue&type=template&id=794db360&scoped=true&"
import script from "./NewRsInspectionReport.vue?vue&type=script&lang=js&"
export * from "./NewRsInspectionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794db360",
  null
  
)

export default component.exports